import React from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Stack,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";

export default function CoverImageSection({
  coverImage,
  setCoverImage,
}) {
  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      setCoverImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDelete = () => {
    setCoverImage(null);
  };

  return (
    <Paper
      elevation={4}
      sx={{
        p: 4,
        mb: 5,
        borderRadius: 4,
        background:
          "linear-gradient(135deg, #fff7f2 0%, #ffffff 100%)",
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          fontSize: "1.2rem",
          fontWeight: 800,
          textAlign: "center",
          mb: 3,
          letterSpacing: 0.5,
        }}
      >
        Cover Page Portrait
      </Typography>

      {/* Upload Area */}
      <Box
        sx={{
          border: "2px dashed #FF9966",
          borderRadius: 4,
          p: 4,
          textAlign: "center",
          transition: "0.3s",
          backgroundColor: "#fff",
          "&:hover": {
            boxShadow: "0 10px 25px rgba(255,150,100,0.25)",
          },
        }}
      >
        {!coverImage && (
          <>
            <CloudUploadIcon
              sx={{ fontSize: 50, color: "#FF9966", mb: 1 }}
            />
            <Typography sx={{ mb: 2, color: "#555" }}>
              Upload a portrait image for the cover page
            </Typography>

            <Button
              variant="contained"
              component="label"
              sx={{
                px: 4,
                fontWeight: 600,
                background:
                  "linear-gradient(90deg, #FF9966, #FF5E62)",
              }}
            >
              Choose Image
              <input
                hidden
                type="file"
                accept="image/*"
                onChange={handleUpload}
              />
            </Button>
          </>
        )}

        {coverImage && (
          <Stack spacing={3} alignItems="center">
            {/* Oval Preview */}
            <Box
              sx={{
                width: 170,
                height: 250,
                borderRadius: "50% / 40%",
                overflow: "hidden",
                boxShadow:
                  "0 15px 30px rgba(0,0,0,0.25)",
                border: "4px solid #fff",
              }}
            >
              <img
                src={coverImage}
                alt="Cover Preview"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>

            {/* Action Buttons */}
            <Stack direction="row" spacing={2}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<CloudUploadIcon />}
              >
                Change
                <input
                  hidden
                  type="file"
                  accept="image/*"
                  onChange={handleUpload}
                />
              </Button>

              <Button
                variant="contained"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={handleDelete}
              >
                Remove
              </Button>
            </Stack>
          </Stack>
        )}
      </Box>
    </Paper>
  );
}
